import { debugLog } from "../Utils/LogUtils";
import { generateJSON } from './JSONGeneration';
import {apiRequest} from '../Utils/APIUtils';
import {useState} from 'react';
import TextInput from "../DataCollection/Inputs/TextInput";
import {handleChange} from "../Utils/DataCollectionUtils";

const JSONViewer = ({data}) => {

    const [newOwner, setNewOwner] = useState('');
    const [ownerChanged, setOwnerChanged] = useState(false);

    //Artificially add the _id to the data object
    // This could be done better!
    data = {
        ...data,
        _id: data.enrollment._id //application._enrollmentId,
    }

    const json = generateJSON(data);

    function saveEnrolment() {
        apiRequest('api/enrollment', 'POST', data)
            .then(response => {
                debugLog(response); // Handle success response

                //If we don't have an _id, replace the URL with the new one
                //This is because we are saving for the first time
                if (!data._id) {
                    window.history.replaceState("", "Enrolment", "/enrolment/" + response._id);
                }

                //Artificially add the _id to the data object
                // This could be done better!
                data.setApplication({
                    ...data.application,
                    _enrollmentId: response._id
                });

            }).catch(error => {
                console.error('There was a problem with your fetch operation:', error);
            });
    }

    const changeOwner = () => {
        apiRequest(`api/change-enrolment-user/${data.enrollment._id}/${newOwner}`, 'POST')
            .then(response => {
                debugLog(response); // Handle success response
                if (response._id) {
                    setOwnerChanged(true);
                }
            }).catch(error => {
                console.error('There was a problem with your fetch operation:', error);
            });
    }

    const uploadXML = () => {
        apiRequest(`api/upload-enrolment-xml/${data.enrollment._id}`, 'GET')
            .then(response => {
                debugLog(response); // Handle success response
            })
            .catch(error => {
                console.error('There was a problem with your fetch operation:', error);
            });
    }
    return (
        <div>
            <h1>JSON Viewer</h1>
            <div>
                <input type={"text"} placeholder={"New owner"} value={newOwner} onChange={(e) => {setNewOwner(e.target.value)}}/>
                <button onClick={changeOwner} >Change owner</button>
                {ownerChanged &&
                    <div>Owner changed.  You will no longer be able to view/edit this enrolment using this account.</div>
                }
            </div>
            <div>
                <button onClick={uploadXML}>Upload XML</button>
            </div>
            <span><button onClick={saveEnrolment}>Save JSON</button></span>
            <pre>{json}</pre>
        </div>
    );
}

export default JSONViewer;